// 过滤规则
const filterTable = {
	directSeeding: (ctx, item) => {
		if (ctx.devicetype === 'app') {
			return '';
		} else if (ctx.devicetype === 'mobile') {
			item._url = item.url;
            // item.url = `https://izhibo.ifeng.com/live.html?liveid=${item.url}`;
            item.url = `https://flive.ifeng.com/live/${item.url}.html`;
		} else {
			item._url = item.url;
            // item.url = `https://zhibo.ifeng.com/video.html?liveid=${item.url}`;
            item.url = `https://flive.ifeng.com/live/${item.url}.html`;
		}
	},
    live: (ctx, item) => {
		if (ctx.devicetype === 'app') {
			return '';
        }
        if(item.liveId) {
            if (ctx.devicetype === 'mobile' ) {
                item._url = item.url;
                // item.url = `https://izhibo.ifeng.com/live.html?liveid=${item.liveId}`;
                item.url = `https://flive.ifeng.com/live/${item.liveId}.html`;

            } else {
                item._url = item.url;
                // item.url = `https://zhibo.ifeng.com/video.html?liveid=${item.liveId}`;
                item.url = `https://flive.ifeng.com/live/${item.liveId}.html`;
            }
        }
	},
	topic: (ctx, item) => {
		if (ctx.devicetype === 'app') {
			return '';
		} else if (ctx.devicetype === 'mobile') {
			item._url = item.url;
			item.url = item.wapUrl||item.wwwUrl;
		}else{
			item._url = item.url;
			item.url = item.wwwUrl||item.wapUrl;
		}
	},
	// threeTerminalTopic: (ctx, item) => {
	// 	if (ctx.devicetype === 'app') {
	// 		return '';
	// 	} else if (ctx.devicetype === 'mobile') {
	// 		item.url = item.wapUrl||item.wwwUrl;
	// 	}else{
	// 		item.url = item.wwwUrl||item.wapUrl;
	// 	}
	// },
	survey: (ctx, item) => {
		if (ctx.devicetype === 'app') {
			return '';
		} else {
			item._url = item.url;
			item.url = item.wwwUrl || item._url;
		}
	},
	// 前置规则，优先使用该规则
	prefix: (ctx, item) => {
		if (item[`${ctx.devicetype}Display`] == 0 || item[`${ctx.devicetype}Display`] == 'false') {
			return 'delete';
		}
	},
};

/**
 * 推荐位数据过滤函数
 * @param  {Object}  ctx   服务端调用：调用上下文ctx，前端调用：{host: ..., devicetype: ....}
 * @param  {Array}   list  推荐位数据
 * @param  {string}  use   前后端标识，ui：代表前端调用，server代表服务端调用
 * @return {*}
 */
let recommondFitler = (ctx, list, use = 'server') => {
	try {
		if (Object.prototype.toString.call(list) !== '[object Array]') {
			return list;
		}
		let devicetype = '';
		let domainPrefix = '';

		if (use == 'server') {
			devicetype = ctx.headers['devicetype'] || ctx.query.devicetype;
			domainPrefix = ctx.domainPrefix || ctx.query.domainPrefix || '';
			if (domainPrefix == 'local.shank') {
				devicetype = 'app';
			}

			devicetype = devicetype === 'ie78' ? 'pc' : devicetype;
		} else {
			devicetype = ctx.devicetype;
			domainPrefix = (ctx.host || '').replace(/\.\w+\.\w+$/, '').replace(/^test\./, '');
		}

		return list.filter(item => {
			if (Object.prototype.toString.call(item) == '[object Object]') {

				if(item.children && Object.prototype.toString.call(item.children) == '[object Array]' ){
					recommondFitler(ctx, item.children, use)
				}
				// 优先过滤
				let action = filterTable.prefix({ devicetype, domainPrefix }, item);
				if (action == 'delete') {
					return false;
				}

				let filter = filterTable[item.type];

				if (filter) {
					let action = filter({ devicetype, domainPrefix }, item);

					if (action === 'delete') {
						return false;
					}
				}
			} else {
				return false;
			}

			return true;
		});
	} catch (error) {
		console.error(error);
		return list;
	}
};


module.exports = recommondFitler;
